import { For, type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { type AgentModeView, toolChoices } from '../lib/agent-modes';
import { Field } from './Field';

// The Advanced drawer's tools checklist (#5211, epic #5200) — the mode's ceiling
// as a checklist, floor tools checked and locked, in ceiling order. Reviewer's
// ceiling is empty (`AGENT_MODE_TOOL_CEILINGS.reviewer = []`), so this renders
// NOTHING for it — omitted, never a disabled section standing in for one.
//
// Presenter, one reason to change: what the checklist looks like. The write
// (`withTool` → `ModeSaves.setTools`) is the caller's, same split as
// `AgentModeRow`'s own tools block, which this mirrors minus the switch/reset a
// card-level control already owns.

export type AgentModeToolsFieldProps = {
  readonly view: AgentModeView;
  readonly idPrefix: string;
  readonly busy: boolean;
  readonly canEdit: boolean;
  readonly onTool: (tool: string, on: boolean) => void;
};

export function AgentModeToolsField(props: AgentModeToolsFieldProps): JSX.Element {
  const choices = () => toolChoices(props.view);
  return (
    <Show when={choices().length > 0}>
      <Field
        as="fieldset"
        id={`${props.idPrefix}-tools`}
        label={t('agent_modes.tools_legend', { mode: t(`agent_modes.mode.${props.view.key}`) })}
      >
        {(a11y) => (
          <ul class="agent-mode__tools">
            <For each={choices()}>
              {(choice) => (
                <li>
                  <label class="agent-mode__tool">
                    <input
                      id={`${a11y.id}-${choice.tool}`}
                      type="checkbox"
                      checked={choice.checked}
                      disabled={props.busy || choice.floor || !props.canEdit}
                      onChange={(e) => {
                        const on = e.currentTarget.checked;
                        e.currentTarget.checked = choice.checked;
                        props.onTool(choice.tool, on);
                      }}
                    />
                    <span class="agent-mode__tool-name">{choice.tool}</span>
                    <Show when={choice.floor}>
                      <span class="agent-mode__floor">{t('agent_modes.floor')}</span>
                    </Show>
                  </label>
                </li>
              )}
            </For>
          </ul>
        )}
      </Field>
      <Show when={props.view.dropped_tools.length > 0}>
        <p class="field__desc">
          {t('agent_modes.dropped', { tools: props.view.dropped_tools.join(', ') })}
        </p>
      </Show>
    </Show>
  );
}
